import { withNamespaces } from "react-i18next";
import { RiInformationLine } from "react-icons/ri";
import { Badge, Card, CardBody, Col, Row, Table, UncontrolledTooltip } from "reactstrap";
import { KYBMonitoringAlertsStatuses, KYBPEPTierValues, KYBScreeningDataSets } from "src/modules/3rd-party-management/constants";
import RelevancyActions from "src/modules/3rd-party-management/pages/admin/compliance/components/profile-detail/RelevancyActions";

const MatchMonitoringResultHeader = ({ t, monitoringDetailQuery }) => {
    const {
        data: resultData
    } = monitoringDetailQuery;

    return (
        <div>
            <Card className="mb-3">
                <CardBody>
                    <Row>
                        <Col md={2}>
                            {resultData.profile_image ? (
                                <img
                                    style={{
                                        maxWidth: '120px'
                                    }}
                                    src={resultData.profile_image}
                                    alt="profile"
                                    className="img-fluid me-1"
                                />
                            ) : (
                                <span className="text-muted">{t('No Image')}</span>
                            )}
                        </Col>

                        <Col md={10} className="d-flex flex-column gap-2">
                            <div className="d-flex align-items-center justify-content-between">
                                <h4 className="mb-0">
                                    {resultData.match_name}
                                    <span>
                                        <span
                                            id="match-name-tooltip"
                                            className="ms-1"
                                            style={{ cursor: "pointer" }}>
                                            <RiInformationLine size="14" />
                                        </span>
                                        <UncontrolledTooltip
                                            target="match-name-tooltip"
                                        >
                                            {t("The name on the profile that has been matched in the search.")}
                                        </UncontrolledTooltip>
                                    </span>
                                </h4>

                                <RelevancyActions
                                    complianceType="monitoring"
                                    id={resultData.id}
                                    isFalsePositive={resultData.is_false_positive}
                                />
                            </div>

                            {/* Datasets */}
                            <div className="d-flex gap-1 flex-wrap mb-2">
                                {(resultData?.datasets || []).map((datasetKey, index) => {
                                    return (
                                        <Badge
                                            key={index}
                                            id={`row-dataset-${datasetKey}`}
                                            className="bg-info"
                                        >
                                            {t(KYBScreeningDataSets[datasetKey]?.title)}

                                            <UncontrolledTooltip
                                                target={`row-dataset-${datasetKey}`}
                                            >
                                                {t(KYBScreeningDataSets[datasetKey]?.description)}
                                            </UncontrolledTooltip>
                                        </Badge>
                                    )
                                })}
                            </div>

                            <div>
                                <Table size="sm" borderless>
                                    <tbody>
                                        <tr>
                                            <th
                                                style={{
                                                    width: '140px'
                                                }}
                                            >
                                                {t('Score')}
                                                <span
                                                    id="score-tooltip"
                                                    className="ms-1"
                                                    style={{ cursor: "pointer" }}>
                                                    <RiInformationLine />
                                                </span>
                                                <UncontrolledTooltip
                                                    target="score-tooltip"
                                                >
                                                    {t("The match score of the profile.")}
                                                </UncontrolledTooltip>
                                            </th>
                                            <td>
                                                {resultData.score}{' '}{t('(Min: 50, Max: 100)')}
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>
                                                {t('PEP Tier')}
                                            </th>
                                            <td>
                                                {t(KYBPEPTierValues?.[resultData.pep_tier]?.title ?? "Not provided")}

                                                <span
                                                    id="pep-tier-tooltip"
                                                    className="ms-1"
                                                    style={{ cursor: "pointer" }}>
                                                    <RiInformationLine />
                                                </span>
                                                <UncontrolledTooltip
                                                    target="pep-tier-tooltip"
                                                >
                                                    {t("Defines the PEP tier of the matched person. Where PEP Tier 1 indicates senior roles, PEP Tier 2 - middle-ranking, and PEP Tier 3 - junior officials.")}
                                                </UncontrolledTooltip>
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>
                                                {t('Match Status')}
                                            </th>
                                            <td>
                                                {t(KYBMonitoringAlertsStatuses?.[resultData.current_status]?.title)}

                                                {KYBMonitoringAlertsStatuses?.[resultData.current_status]?.description ? (
                                                    <>
                                                        <span
                                                            id="tooltip-match-status-desc"
                                                            className="ms-1"
                                                            style={{ cursor: "pointer" }}>
                                                            <RiInformationLine />
                                                        </span>
                                                        <UncontrolledTooltip
                                                            target="tooltip-match-status-desc"
                                                        >
                                                            {t(KYBMonitoringAlertsStatuses[resultData.current_status].description)}
                                                        </UncontrolledTooltip>
                                                    </>
                                                ) : null}
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </div>
    )
}

export default withNamespaces()(
    MatchMonitoringResultHeader
)